export const CLOSE_MODAL_TOOLTIP = 'modalTooltip/CLOSE_MODAL_TOOLTIP';
export const OPEN_MODAL_TOOLTIP = 'modalTooltip/OPEN_MODAL_TOOLTIP';